import { Button } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { CompleteDisabledReasonStyled, FooterStyled } from './styled';
import { PAGE_FOOTER_BACK_BTN_TEST_ID, PAGE_FOOTER_COMPLETE_BTN_TEST_ID } from '../../constants';

export interface PageFooterProps {
  onBack: () => void;
  onComplete?: () => void;
  backButtonText?: string;
  completeButtonText?: string;
  disableCompleteButton?: boolean;
  completeDisabledReason?: string;
  ['data-test-id']?: string;
  className?: string;
}

/** @deprecated: use PageFooter from the components library instead */
const PageFooter: React.FC<PageFooterProps> = observer((props) => {
  const {
    onBack,
    onComplete,
    backButtonText,
    completeButtonText,
    disableCompleteButton = false,
    completeDisabledReason,
    className,
  } = props;
  return (
    <FooterStyled className={className}>
      <Button
        onClick={onBack}
        size="large"
        width="24rem"
        type="outlined"
        data-test-id={PAGE_FOOTER_BACK_BTN_TEST_ID}
        data-test-for={props['data-test-id']}
      >
        {backButtonText || 'Back'}
      </Button>
      {onComplete && (
        <div>
          <Button
            color="primary"
            onClick={onComplete}
            size="large"
            disabled={disableCompleteButton}
            width="24rem"
            data-test-id={PAGE_FOOTER_COMPLETE_BTN_TEST_ID}
            data-test-for={props['data-test-id']}
          >
            {completeButtonText || 'Complete'}
          </Button>
          {disableCompleteButton && completeDisabledReason ? (
            <CompleteDisabledReasonStyled>{completeDisabledReason}</CompleteDisabledReasonStyled>
          ) : null}
        </div>
      )}
    </FooterStyled>
  );
});

export default PageFooter;
